module.exports = __webpack_public_path__ + "img/receberbox-gh.e31b13a2.png";